import Header from '@components/containers/header';
import styled from '@emotion/styled';
import { forwardRef, memo } from 'react';

interface ChatHeaderProps {
    title: string;
}

const HeaderRef = styled.div`
    width: 100%;
`;

const ChatHeader = forwardRef<HTMLDivElement, ChatHeaderProps>(
    ({ title }, ref) => {
        return (
            <HeaderRef ref={ref}>
                <Header
                    left={{ display: 'back' }}
                    center={{
                        display: 'text',
                        text: { title },
                    }}
                />
            </HeaderRef>
        );
    }
);

ChatHeader.displayName = 'ChatHeader';

export default memo(ChatHeader);
